import {FormattedDate} from '../../shared/components';
import {TableRow, TableRowColumn} from 'material-ui/Table';
import {UserListRowActions} from './';
import React, {PropTypes} from 'react';

export default function UserListRow({user}) {
  return (
    <TableRow>
      <TableRowColumn>{user.get('email')}</TableRowColumn>
      <TableRowColumn>{user.get('roles').toArray().join(', ')}</TableRowColumn>
      <TableRowColumn><FormattedDate date={user.get('lastLoginDate')} /></TableRowColumn>
      <TableRowColumn><UserListRowActions user={user} /></TableRowColumn>
    </TableRow>
  );
}

UserListRow.propTypes = {
  user: PropTypes.object.isRequired
};



// WEBPACK FOOTER //
// ./app/features/users/components/UserListRow.js